/* eslint-disable */
export default {
  init () {
    // JavaScript to be fired on the home page
    updateBlog();

    $('.filter').click(function(){
      updateBlog();
    })

    function updateBlog() {
      var filter = $('#filter');
      var choices = {};

      $('.contents').remove();
      $('.filter-output').empty();

      $('input[type=radio]:checked').each(function() {
        choices[this.name] = this.value;
      });

      $.ajax({
        url: window.request_ajax_script.ajax_url,
        type :'POST',
        data : {
          'action' : 'call_post',
          'choices' : choices,
        },

        success: function (result) {
          $('html,body').animate({scrollTop: 30}, 'slow');
          $('.blog-content').html(result);
        },
      });
    }

  },
  finalize () {

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/templateBlog.js


// WEBPACK FOOTER //
// ./scripts/routes/templateBlog.js